import React from "react";
import { Divider as ChakraDivider } from "@chakra-ui/react";

const Divider = (color) => {
  return (
    <ChakraDivider w="100%" color={color ? color : "black"} />
  );
};

export default Divider;
